export const RESET_COLORS = "loadSettings";
